import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import type { ThemeContextValue } from '@/hooks/shared/useThemeColors';
import { AuthHeader } from '@/components/auth/AuthHeader';
import { useAppSelector } from '@/store';

type Props = {
  children: React.ReactNode;
};

export const AuthDesktopLayout: React.FC<Props> = ({ children }) => {
  const styles = useThemedStyles(makeStyles);
  const { user } = useAppSelector((state) => state.auth);
  const isAdminMode = user?.roles && user.roles.length > 0;

  const image = isAdminMode
    ? require('@/assets/images/login.png')
    : require('@/assets/images/sign-up.png');

  return (
    <View style={styles.pageWrapper}>
      <AuthHeader show={true} />

      <View style={styles.splitContainer}>
        <View style={styles.imagePane}>
          <Image source={image} style={styles.image} resizeMode="cover" />
        </View>

        <View style={styles.formPane}>{children}</View>
      </View>
    </View>
  );
};

const makeStyles = ({ colors, semantic }: ThemeContextValue) => StyleSheet.create({
  pageWrapper: {
    flex: 1,
    minHeight: '100vh' as any,
    backgroundColor: colors.bg.base,
  },
  splitContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: semantic.border.secondary,
    borderBottomWidth: 1,
    maxWidth: 1200,
    alignSelf: 'center',
    width: '100%',
  },
  imagePane: {
    display: 'flex' as any,
    width: 384,
    height: 'calc(100vh - 97px)' as any,
    flexShrink: 0,
    overflow: 'hidden',
    position: 'relative' as any,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' as any,
    position: 'absolute' as any,
    top: 0,
    left: 0,
  },
  formPane: {
    width: 512,
    borderColor: semantic.border.secondary,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    height: 'calc(100vh - 97px)' as any,
    flexShrink: 0,
    overflow: 'auto' as any,
    backgroundColor: colors.card.bg,
  },
});
